var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.color && _vm.flowerType)?_c('img',{staticClass:"flower-image",attrs:{"alt":_vm.color + ' ' + _vm.flowerType,"src":_vm.flowerImage()}}):_c('div',{staticClass:"flower-image"})}
var staticRenderFns = []

export { render, staticRenderFns }